import styled from 'styled-components'
import { TextField } from '@material-ui/core'
import { ContainerSombra } from '../../components/ContainerSombra'

export const detalheInadimplenciaStyles = {
  Container: styled(ContainerSombra)`
    padding: 24px;
    margin-top: 16px;
  `,
  ContainerFormDataButton: styled.div`
    gap: 8px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  `,
  TextFieldDataFim: styled(TextField)`
    .MuiFormHelperText-root {
      position: absolute;
      margin-top: 40px;
    }
  `,
  ContainerFormulario: styled.form`
    margin-top: 51px;
  `
}
